<div class="factory-page">
  <div class="factory-card">
    <div class="factory-header">
      <mat-icon>factory</mat-icon>
      <h2>Factory</h2>
    </div>

    @if (loadingFactories) {
      <p class="factory-muted">Loading factories…</p>
    }

    @if (loadingList && !loadingFactories) {
      <p class="factory-muted">Loading production orders…</p>
    }

    <form [formGroup]="factoryForm" class="factory-form">
      <mat-form-field appearance="fill">
        <mat-label>Factories</mat-label>
        <input
          matInput
          [formControl]="factorySearchCtrl"
          [matAutocomplete]="autoFac"
          (blur)="onFactorySearchBlur()"
          placeholder="Type to search…"
        >
        <mat-autocomplete
          #autoFac="matAutocomplete"
          [displayWith]="displayFactoryFn"
          (optionSelected)="onFactoryOptionSelected($event)">
          @for (f of (filteredFactories$ | async) ?? []; track f.id) {
            <mat-option
              [value]="f"
              (mousedown)="$event.preventDefault()">
              {{ factoryLabel(f) }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (!loadingFactories && !factories.length) {
          <mat-hint>No factories available for your account</mat-hint>
        }
        @if (!loadingFactories && factories.length && !factoryForm.get('factoryId')?.value) {
          <mat-hint>Type or select a factory to load production orders</mat-hint>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Production order</mat-label>
        <mat-select
          formControlName="prodOrderId"
          (selectionChange)="onProductionOrderChange()"
          [disabled]="loadingList || loadingFactories || !prodOrders.length">
          @for (o of prodOrders; track o.id) {
            <mat-option [value]="o.id">{{ productionOrderLabel(o) }}</mat-option>
          }
        </mat-select>
        @if (!loadingList && prodOrders.length && prodOrderTotalCount > prodOrders.length) {
          <mat-hint>Showing {{ prodOrders.length }} of {{ prodOrderTotalCount }} orders (load window matches production tracking pagination).</mat-hint>
        }
        @if (!loadingList && factoryForm.get('factoryId')?.value != null && !prodOrders.length && !loadingFactories) {
          <mat-hint>No production orders for this factory.</mat-hint>
        }
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Material Arrival Date</mat-label>
        <input matInput [matDatepicker]="materialPicker" formControlName="materialArrivalDate">
        <mat-datepicker-toggle matIconSuffix [for]="materialPicker"></mat-datepicker-toggle>
        <mat-datepicker #materialPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Mass Production Start Date</mat-label>
        <input matInput [matDatepicker]="massPicker" formControlName="massProdStartDate">
        <mat-datepicker-toggle matIconSuffix [for]="massPicker"></mat-datepicker-toggle>
        <mat-datepicker #massPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Assembly Start Date</mat-label>
        <input matInput [matDatepicker]="assemblyPicker" formControlName="assemblyStartDate">
        <mat-datepicker-toggle matIconSuffix [for]="assemblyPicker"></mat-datepicker-toggle>
        <mat-datepicker #assemblyPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Mass Production Complete Date</mat-label>
        <input matInput [matDatepicker]="prodCompletePicker" formControlName="actualProdComplete">
        <mat-datepicker-toggle matIconSuffix [for]="prodCompletePicker"></mat-datepicker-toggle>
        <mat-datepicker #prodCompletePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Packing Start Date</mat-label>
        <input matInput [matDatepicker]="packingPicker" formControlName="packingStartDate">
        <mat-datepicker-toggle matIconSuffix [for]="packingPicker"></mat-datepicker-toggle>
        <mat-datepicker #packingPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>QC Inspection Date</mat-label>
        <input matInput [matDatepicker]="qcPicker" formControlName="qcInspectionDate">
        <mat-datepicker-toggle matIconSuffix [for]="qcPicker"></mat-datepicker-toggle>
        <mat-datepicker #qcPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Actual Ship Date (ETD)</mat-label>
        <input matInput [matDatepicker]="etdPicker" formControlName="actualEtd">
        <mat-datepicker-toggle matIconSuffix [for]="etdPicker"></mat-datepicker-toggle>
        <mat-datepicker #etdPicker></mat-datepicker>
      </mat-form-field>

      <div class="actions">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="onSave()"
          [disabled]="saving || loadingList || loadingFactories">
          {{ saving ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </form>
  </div>

  <div class="factory-card">
    <div class="factory-header">
      <mat-icon>local_shipping</mat-icon>
      <h2>Factory Offers to Us</h2>
    </div>

    <form [formGroup]="sampleOfferForm" class="factory-form">
      <mat-form-field appearance="fill">
        <mat-label>Sending to</mat-label>
        <mat-select formControlName="destinationOffice">
          <mat-option value="Ningbo">Ningbo office</mat-option>
          <mat-option value="NYC">NYC direct</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Sample name</mat-label>
        <input matInput formControlName="sampleName">
      </mat-form-field>

      <div class="factory-two-up">
        <mat-form-field appearance="fill">
          <mat-label>Quantity</mat-label>
          <input matInput type="number" formControlName="quantity">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>FOB cost</mat-label>
          <input matInput type="number" formControlName="fobCost">
        </mat-form-field>
      </div>

      <mat-form-field appearance="fill">
        <mat-label>Notes</mat-label>
        <textarea matInput rows="3" formControlName="notes"></textarea>
      </mat-form-field>

      <div class="actions">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="onSubmitSampleOffer()"
          [disabled]="savingOffer || loadingFactories || !factoryForm.get('factoryId')?.value">
          {{ savingOffer ? 'Submitting…' : 'Submit Offer' }}
        </button>
      </div>
    </form>

    <div class="sample-offers">
      <h3>Recent Offers</h3>
      @if (loadingOffers) {
        <p class="factory-muted">Loading sample offers…</p>
      }
      @if (!loadingOffers && !recentOffers.length) {
        <p class="factory-muted">No sample offers submitted yet.</p>
      }
      @for (offer of recentOffers; track offer.sample_id_pk) {
        <div class="sample-offer-row">
          <div>
            <strong>{{ offer.sample_name || 'Unnamed sample' }}</strong>
            <span>{{ offer.office_location || 'No destination' }} · {{ offer.status || 'requested' }}</span>
          </div>
          <div class="sample-offer-meta">
            @if (offer.quantity != null) {
              <span>Qty {{ offer.quantity }}</span>
            }
            @if (offer.fob_cost != null) {
              <span>{{ offer.fob_cost | currency }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
